import Vue from "vue"
let v = new Vue();
export default {
  msg(text, type = "error") {
    v.$message({
      duration: 1200,
      type: type,
      message: text,
    })
  },
  menuList(data) {
    let _newList = [];
    data.forEach(item => {
      if (item.level == 1) {
        //1级菜单 - 新加
        _newList.push({
          id: item.id,
          icon: item.icon,
          is_del: item.is_del,
          is_show: item.is_show,
          level: item.level,
          label: item.menu_name,
          menu_name: item.menu_name,
          parent_code: item.parent_code,
          sort: item.sort,
          updated_at: item.updated_at,
          url: item.url,
          children:[]
        });
      } else if (item.level == 2) {
        _newList.forEach(item2 => {
          if (item2.id == item.parent_code) {
            // item2.children = [];
            item2.children.push({
              id: item.id,
              icon: item.icon,
              is_del: item.is_del,
              is_show: item.is_show,
              level: item.level,
              label: item.menu_name,
              menu_name: item.menu_name,
              parent_code: item.parent_code,
              sort: item.sort,
              updated_at: item.updated_at,
              url: item.url,
              children:[]
            });
          }
        });
      } else if (item.level == 3) {
        _newList.forEach(item3 => {
          if (item3.children.length >= 1) {
            let _item3Children = item3.children.filter(
              item4 => item4.id == item.parent_code
            )[0];
            if (_item3Children) {
              // _item3Children.children = [];
              _item3Children.children.push({
                id: item.id,
                icon: item.icon,
                is_del: item.is_del,
                is_show: item.is_show,
                level: item.level,
                label: item.menu_name,
                menu_name: item.menu_name,
                parent_code: item.parent_code,
                sort: item.sort,
                updated_at: item.updated_at,
                url: item.url,
                children:[]
              });
            }
          }
        });
      }
    });
    
    return _newList;
  }
}